<div class="key-objectives">
  <div class="key-objectives--container">
    <h2 class="key-objectives--title">Key Objectives:</h2>
    
    <div class="key-objectives--list">
      <div class="key-objective--item" *ngFor="let objective of objectives; let i = index">
        <div class="key-objective--number">
          <span class="key-objective--number-text">{{ i + 1 }}</span>
        </div>
        <p class="key-objective--text">{{ objective }}</p>
      </div>
    </div>
  </div>
</div>
